// Flow types automatically removed

import { Consumer } from './helpers/queryParamsContext.js';

/**
 * Helper functions for converting a query param value into some explicit type,
 * making it easier and cleaner to use as an enduser. Could potentially just be
 * done by the Provider instead of the Consumer
 */
function getInt(param) {
    const rawInt = parseInt(param);
    return isNaN(rawInt) ? null : rawInt;
}

function getArray(param) {
    if (param) {
        return param.split(',');
    }

    return [];
}
/**
 * Converts the internal context provided to the actual Consumer component to a
 * simple API to use within the `mapQueryParamsToProps`.
 */

function getQueryParamContext(context) {
    return {
        readStr: key => context.getQueryParam(key) || null,
        readInt: key => getInt(context.getQueryParam(key)),
        readArray: key => getArray(context.getQueryParam(key)),
    };
}
/**
 * Component the provides an API for child React Elements to read/write
 * query params. In reality, it's pretty generic in functionality, as it
 * just maps some values back and forth from some source (e.g. Redux)
 *
 * Note: rename to something more relevant e.g. QueryParamsView
 */

export function QueryParamsConsumer(props) {
    return (
        <Consumer>
            {context =>
                props.children(
                    props.mapQueryParamsToProps(getQueryParamContext(context)),
                    (key, value) =>
                        context.mergeQueryParamsObj(
                            props.mapUpdateToQueryParams
                                ? props.mapUpdateToQueryParams(key, value)
                                : {
                                      [key]: value,
                                  }
                        ),
                    context.reset
                )
            }
        </Consumer>
    );
}
